import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AddUsersModal from "./AddUsersModal";
import axios from "axios";

export default function StudentListDetails() {

  const { listId } = useParams();
  const [members, setMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchMembers = async () => {
    const res = await axios.get(
      `https://api.ilogically.com/api/users/lists/${listId}/members?appToken=87adfacc2dffc65ae172d59a9f0badda`
    );
    setMembers(res.data);
  };

  useEffect(() => {
    fetchMembers();
  }, [listId]);

  const removeUser = async (userId) => {
    await axios.delete(
      `https://api.ilogically.com/api/users/lists/${listId}/members/${userId}?appToken=87adfacc2dffc65ae172d59a9f0badda`
    );
    fetchMembers();
  };


 const addUser = async (userId) => {

    try {
  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";


      await axios.post(
        `${API_BASE}/users/lists/${listId}/members`,
        { userId },
        {
          params: { appToken: APP_TOKEN }
        }
      );
fetchMembers()

    } catch (err) {
      console.error("Add error", err);
    }
  };
  return (
    <div>
      <h2>List Members</h2>

      <button onClick={() => setShowModal(true)}>
        + Add Users
      </button>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Remove</th>
          </tr>
        </thead>

        <tbody>
          {members.map((u) => (
            <tr key={u.ID}>
              <td>{u.firstName} {u.lastName}</td>
              <td>{u.userEmail}</td>
              <td>{u.role}</td>
              <td>
                <button onClick={() => removeUser(u.ID)}>
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <AddUsersModal
        listId={listId}
          add={true}
        title={"Add Users To List"}
          onClose={() => setShowModal(false)}
          
          addUser={addUser}
        />
      )}
    </div>
  );
}